<mat-toolbar color="accent" class="toolbar-details" mat-scroll-shrink>
  <button mat-icon-button matTooltip="Back" (click)="back()">
    <ca-icon [key]="'BACK'"></ca-icon>
  </button>
  <span class="toolbar-details-title">{{pageTitle}}</span>

  <span class="example-fill-remaining-space">&nbsp;</span>

  <!--<button *ngIf="quoteServices.length > 0"
          matTooltip="Add Service"
          mat-icon-button
          [matMenuTriggerFor]="newQuoteMenu"
          [(disabled)]="isQuoteClosed">
    <ca-icon [key]="'QUOTE_ADD_SERVICE'"></ca-icon>
  </button>
  <button *ngIf="quoteServices.length === 0"
          matTooltip="Add Service"
          [matMenuTriggerFor]="newQuoteMenu"
          mat-icon-button>
    <ca-icon [key]="'QUOTE_ADD_SERVICE'"></ca-icon>
  </button>
  <mat-menu #newQuoteMenu="matMenu">
    <button mat-menu-item type="button" (click)="addNewQuoteService(QUOTE_SERVICE_TYPE.ACCESS_CIRCUIT)">
      Access Circuits
    </button>
    <button mat-menu-item type="button" (click)="addNewQuoteService(QUOTE_SERVICE_TYPE.P2P)">
      Point to Point
    </button>
    <button mat-menu-item type="button" (click)="addNewQuoteService(QUOTE_SERVICE_TYPE.OTHER)">
      Other Services
    </button>
  </mat-menu>
  <button mat-icon-button
          matTooltip="Refresh List"
          (click)="refresh()">
    <ca-icon [key]="'REFRESH'"></ca-icon>
  </button>
  <button mat-icon-button
          matTooltip="Report"
          [matMenuTriggerFor]="srmReportMenu">
    <ca-icon [key]="'QUOTE_SRM_REPORT'"></ca-icon>
  </button>
  <mat-menu #srmReportMenu="matMenu">
    <ng-container *ngIf="!selectedQuoteService">
      <button mat-menu-item type="button" (click)="srmReport(SRM_REPORTS.QUOTE_SUMMARY, SRM_REPORT_VIEW_TYPE.VIEW)">
        Quote Summary Report
      </button>
      <button mat-menu-item type="button" (click)="srmReport(SRM_REPORTS.QUOTE_SUMMARY, SRM_REPORT_VIEW_TYPE.CSV)">
        Quote Summary CSV
      </button>

      <button mat-menu-item type="button"
              (click)="srmReport(SRM_REPORTS.QUOTE_DETAILED_SUMMARY, SRM_REPORT_VIEW_TYPE.VIEW)">
        Quote Detailed Report
      </button>
      <button mat-menu-item type="button"
              (click)="srmReport(SRM_REPORTS.QUOTE_DETAILED_SUMMARY, SRM_REPORT_VIEW_TYPE.CSV)">
        Quote Detailed CSV
      </button>
    </ng-container>
    <ng-container *ngIf="selectedQuoteService">
      <button mat-menu-item type="button"
              (click)="srmReport(SRM_REPORTS.QUOTE_SERVICE_SUMMARY, SRM_REPORT_VIEW_TYPE.VIEW)">
        Service Summary Report
      </button>
      <button mat-menu-item type="button"
              (click)="srmReport(SRM_REPORTS.QUOTE_SERVICE_SUMMARY, SRM_REPORT_VIEW_TYPE.CSV)">
        Service Summary CSV
      </button>
    </ng-container>
  </mat-menu>


  <button *ngIf="tabGroup.isActive(OVERVIEW_TAB_KEY)" mat-icon-button (click)="bulkEmail()"
          [disabled]="!selectedOverviewRows.length">
    <ca-icon [key]="'EMAIL'" [tooltip]="'Email'"></ca-icon>
  </button>


  <div class="vertical-divider" *ngIf="selectedQuoteService"></div>

  <button *ngIf="selectedQuoteService" mat-icon-button (click)="editQuoteService()"
          [disabled]="isClosed">
    <ca-icon [key]="'QUOTE_ADD'" [tooltip]="'Add Quote'"></ca-icon>
  </button>
  <button *ngIf="selectedQuoteService" mat-icon-button (click)="updateRequest()"
          [disabled]="!selectedRequest || isClosed || ( selectedRequest.status === QUOTE_SERVICE_OFFER_STATUS.FAILED )">
    <ca-icon [key]="'QUOTE_UPDATE'" [tooltip]="'Update Quote'"></ca-icon>
  </button>
  <button *ngIf="selectedQuoteService" mat-icon-button (click)="addManual()"
          [disabled]="!selectedRequest || isClosed || selectedRequest.quote_type_id === QUOTE_SERVICE_OFFER_METHOD.MANUAL">
    <ca-icon [key]="'QUOTE_ADD_MANUAL'" [tooltip]="'Add Manual'"></ca-icon>
  </button>
  <div class="vertical-divider" *ngIf="selectedQuoteService"></div>
  <button *ngIf="selectedQuoteService" mat-icon-button (click)="confirmRequest()"
          [disabled]="isClosed  || !enableSelectQuote">
    <ca-icon [key]="'QUOTE_SELECT'" [tooltip]="'Select Quote'"></ca-icon>
  </button>
  <button *ngIf="selectedQuoteService" mat-icon-button (click)="moveInvoiceToDoNotProcess()"
          [disabled]="isClosed">
    <ca-icon [key]="'QUOTE_CLOSE'" [tooltip]="'Close Quote'"></ca-icon>
  </button>
  <button matTooltip="Analyze" mat-icon-button *ngIf="!!(selectedQuoteService && selectedQuoteService.id)"
          (click)="openAnalyzeReport()">
    <ca-icon [key]="'QUOTE_CHART'"></ca-icon>
  </button>

  <div class="vertical-divider"></div>

  <app-document-manager-commands
    *ngIf="isDocumentCommandsVisible()"

    [deleteDocumentActionHandler]="DOCUMENT_MANAGER_SETTINGS.DELETE_DOCUMENT_ACTION"
    [deleteDocumentDisablePredicate]="isDeleteDisabled(selection)"

    [uploadDocumentActionHandler]="DOCUMENT_MANAGER_SETTINGS.UPLOAD_DOCUMENT_ACTION"
    [uploadDocumentDisablePredicate]="false"

    [downloadDocumentActionHandler]="DOCUMENT_MANAGER_SETTINGS.DOWNLOAD_DOCUMENT_ACTION"
    [downloadDocumentDisablePredicate]="isDeleteDisabled(selection)"
  >
  </app-document-manager-commands>

  <div *ngIf="isDocumentCommandsVisible()" class="vertical-divider"></div>

  <button *ngIf="selectedQuoteService" mat-icon-button matTooltip="Download CSV" (click)="csvServiceRequests()">
    <ca-icon [key]="'DOWNLOAD'"></ca-icon>
  </button>
  <button *ngIf="!selectedQuoteService" mat-icon-button matTooltip="Download CSV" (click)="csvSummary()">
    <ca-icon [key]="'DOWNLOAD'"></ca-icon>
  </button>
  <button [disabled]="tabGroup.isActive(3)" mat-icon-button (click)="gridSettings()" matTooltip="Settings">
    <ca-icon [key]="'GRID_SETTINGS'"></ca-icon>
  </button>
  <div class="vertical-divider"></div>
  <button [ngClass]="{'on' : sider?.isActive(SECTIONS.NOTES_SECTION_NAME)}"
          (click)="sider?.toggle(SECTIONS.NOTES_SECTION_NAME)"
          matTooltip="Notes" mat-icon-button>
    <ca-icon [key]="notesCount > 0 ? 'NOTES' : 'NOTES_EMPTY'"></ca-icon>
  </button>
  <button [ngClass]="{'on' : sider?.isActive(SECTIONS.HISTORY_SECTION_NAME)}"
          (click)="sider?.toggle(SECTIONS.HISTORY_SECTION_NAME)"
          matTooltip="History" mat-icon-button>
    <ca-icon [key]="'HISTORY'"></ca-icon>
  </button>-->
</mat-toolbar>


<mat-sidenav-container class="app-content tabbed-content">

  <mat-tab-group (selectedIndexChange)="onTabSelectedIndexChange($event)"
                 [selectedIndex]="selectedTabIndex">
    <mat-tab label="Summary"></mat-tab>
    <mat-tab label="Overview"></mat-tab>
    <mat-tab [label]="service.quote_service_id" *ngFor="let service of quote?.services"></mat-tab>
  </mat-tab-group>

  <div *ngIf="selectedTabIndex === TAB_TYPES.SUMMARY"
       class="app-content-body"
       fxLayout="column wrap"
       fxFlexFill
       fxLayoutGap="15px">
    <div fxFlex="auto" fxLayout="row" fxLayoutGap="15px">
      <mat-card fxFlex fxFlex.sm="50%">
        <mat-card-header>
          Quote Info
        </mat-card-header>
        <mat-card-content class="inner-content">
          <div fxLayout="row" class="entry-list">
            <div fxFlex class="entry-list-item">
              <label>Customer</label>
              <p>
                {{ (quote?.customer?.company) || 'N/A'}}
              </p>
            </div>
            <div fxFlex class="entry-list-item">
              <label>Requestor</label>
              <p>
                {{ (quote?.requester?.full_name) || 'N/A'}}
              </p>
            </div>
            <div fxFlex class="entry-list-item">
              <label>Status</label>
              <p>
                {{ (quote?.quote_status?.value) || 'N/A'}}
              </p>
            </div>
          </div>
          <div fxLayout="row" class="entry-list">

            <div fxFlex class="entry-list-item">
              <label>Request Date</label>
              <p>
                {{ (quote?.request_date | date) || 'N/A'}}
              </p>
            </div>
            <div fxFlex class="entry-list-item">
              <label>Close Date</label>
              <p>
                {{ (quote?.close_date | date) || 'N/A'}}
              </p>
            </div>
            <div fxFlex class="entry-list-item">
              <label>Description</label>
              <p>
                {{ (quote?.quote_description) || 'N/A'}}
              </p>
            </div>
          </div>

        </mat-card-content>
      </mat-card>
      <mat-card fxFlex fxFlex.sm="50%">
        <mat-card-header>
          Sales Info
        </mat-card-header>
        <mat-card-content class="inner-content">
          <div fxLayout="row" class="entry-list">

            <div fxFlex class="entry-list-item">
              <label>Opportunity Type</label>
              <p>
                {{ (quote?.opportunity_type?.value) || 'N/A'}}
              </p>
            </div>
            <div fxFlex class="entry-list-item">
              <label>CRM Opportunity</label>
              <p>
                {{ (quote?.crm_opportunity) || 'N/A'}}
              </p>
            </div>

          </div>
          <div fxLayout="row" class="entry-list">

            <div fxFlex class="entry-list-item">
              <label>Sales Representative</label>
              <p>
                {{ (quote?.sales_representative?.full_name) || 'N/A'}}
              </p>
            </div>
            <div fxFlex class="entry-list-item">
              <label>Sales Engineer</label>
              <p>
                {{ (quote?.sales_engineer?.full_name) || 'N/A'}}
              </p>
            </div>

          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div style="background-color: yellow" fxFlex="1 1 auto">

    </div>
  </div>
  <div *ngIf="selectedTabIndex === TAB_TYPES.OVERVIEW"
       class="app-content-body">Overview
  </div>
  <div *ngIf="selectedTabIndex > TAB_TYPES.OVERVIEW"
       class="app-content-body">Service
  </div>

  <mat-sidenav #panelMore
               [mode]="'side'"
               position="end"
               [opened]="false">

  </mat-sidenav>
</mat-sidenav-container>
